export default {
  TENT: 'bf58b77c-33fd-bcba-1590-09a8db7bc67e',
  CORDON: '8953cee3-c8a4-50dc-226e-6dd7d53ebbb0',
};
